/**
 * @description Sound utility for Trap Tycoon to handle playback of effects and music.
 */
import { log } from "./logger";

const sounds = {
  bgMusic: new Audio("/assets/sounds/bg_theme.mp3"),
  cash: new Audio("/assets/sounds/cash.mp3"),
  attack: new Audio("/assets/sounds/attack.mp3"),
  raid: new Audio("/assets/sounds/raid.mp3"),
  success: new Audio("/assets/sounds/success.mp3"),
  error: new Audio("/assets/sounds/error.mp3"),
};

// Configure Background Music
sounds.bgMusic.loop = true;
sounds.bgMusic.volume = 0.2;

// Global SFX State
let sfxEnabled = true;

export const setSfxEnabled = (enabled) => {
  sfxEnabled = enabled;
};

export const playSound = (soundName) => {
  if (!sfxEnabled) return; // Mute check

  const sound = sounds[soundName];
  if (sound) {
    sound.currentTime = 0; // Reset to start if played rapidly
    sound
      .play()
      .catch((e) =>
        log(
          "SOUNDS",
          "Audio playback blocked by browser until user interacts.",
          e,
        ),
      );
  }
};

export const toggleMusic = (play) => {
  if (play) {
    sounds.bgMusic
      .play()
      .catch((e) => log("SOUNDS", "Music playback blocked.", e));
  } else {
    sounds.bgMusic.pause();
  }
};
